// form
import { useFormContext, Controller } from "react-hook-form";
// @mui
import { TextField, TextFieldProps } from "@mui/material";
import InputMask from "react-input-mask";

// ----------------------------------------------------------------------

type Props = TextFieldProps & {
  name: string;
  mask?: string; // máscara opcional
  keepZero?: boolean; // mantém "0" visível quando o valor numérico é 0 (em vez de esvaziar o campo)
};

export default function RHFTextField({ name, mask, helperText, keepZero, ...other }: Props) {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => {
        // remove 0 inicial se for number (a menos que keepZero esteja ativo)
        const value =
          typeof field.value === "number" && field.value === 0 && !keepZero ? "" : field.value;

        if (mask) {
          return (
            <InputMask
              mask={mask}
              value={value}
              onChange={field.onChange}
              maskChar=""
            >
              {(inputProps: any) => (
                <TextField
                  {...inputProps}
                  fullWidth
                  error={!!error}
                  helperText={error ? error.message : helperText}
                  {...other}
                />
              )}
            </InputMask>
          );
        }

        return (
          <TextField
            {...field}
            fullWidth
            value={value}
            error={!!error}
            helperText={error ? error.message : helperText}
            {...other}
          />
        );
      }}
    />
  );
}
